import * as React from 'react';
import { t } from '@moovly/i18n';
import { ModalContainer, useModal } from '@moovly/ui';
import AddUserContainer from '../containers/AddUserContainer';
import { DefaultModalProps } from '../../../types/modal';

export const AddUserModal: React.FC<DefaultModalProps> = ({ closeModal, setOpen }) => {
  return (
    <ModalContainer title={t('users.add.button')} setOpen={setOpen} confirmButtonText={t('users.add.button')}>
      <AddUserContainer onClose={closeModal} />
    </ModalContainer>
  );
};

export default AddUserModal;
